








































import { computed, defineComponent } from "@vue/composition-api";
import { isAudioFile, isTextFile } from "@/lib/fileHelpers";
import { UploadVaultFile } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import VaultFileItemWithoutPreview from "./components/VaultFileItemWithoutPreview.vue";
import VaultFileItemWithPreview from "./components/VaultFileItemWithPreview.vue";
import { UsedFilesMap } from "../../types";

export default defineComponent({
  name: "VaultFiles",
  components: { LoadingThumbnail, VaultFileItemWithPreview, BaseIcon, VaultFileItemWithoutPreview },
  props: {
    files: { type: Array as () => UploadVaultFile[], required: true },
    thumbnails: { type: Boolean, default: false },
    fileClasses: { type: Object as () => Record<string, string> },
    usedFilesMap: { type: Object as () => UsedFilesMap },
  },
  setup(props) {
    const vaultFiles = computed<UploadVaultFile[]>(() => {
      if (props.thumbnails && props.files.length > 0) {
        const f: UploadVaultFile[] = [];
        while (f.length < 4) {
          props.files.forEach((file: UploadVaultFile) => {
            f.push({ ...file, id: f.length.toString() });
          });
        }
        f.length = 4;
        return f;
      } else return props.files;
    });

    const uploadProgress = (file: UploadVaultFile): number => file?.uploadProgress ?? 100;

    const isFileUsed = (uuid: string) => !!props.usedFilesMap?.[uuid] ?? false;
    const isFileWithoutImage = (file: UploadVaultFile): boolean => isAudioFile(file) || isTextFile(file);
    return {
      vaultFiles,
      isFileUsed,
      uploadProgress,
      isFileWithoutImage,
    };
  },
});
